/** Shared Overview section label — sentence case, quiet, scanable. */
export const OVERVIEW_SECTION_HEADING_CLASS =
  "text-xs font-medium tracking-wide text-muted-foreground";
